import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import config from "../../config";
import { formatApiError } from "../../utilities/apiErrorMessages";
import { clearAuthSession, performLogout } from "../../utilities/authentication";

export const LogOutHand = createAsyncThunk("logout/LogOutHand", async (token) => {
    performLogout(token, config.apiRootUrl)
    return null
})


export const LogoutSlice = createSlice({
    name: "logout",
    initialState: { user: null, error: null, loading: false },
    reducers: {
        unauthentication: () => {
            clearAuthSession();
        },

    },
    extraReducers: {
        [LogOutHand.pending]: (state, action) => {
            state.loading = true

        },
        [LogOutHand.fulfilled]: (state, action) => {
            state.loading = false
            state.user = null



        },
        [LogOutHand.rejected]: (state, action) => {

            state.loading = false
            state.error = formatApiError(action.payload, 'Logout failed')

        },
    }
})

export default LogoutSlice.reducer;
export const { unauthentication } = LogoutSlice.actions